import React from 'react'
import { DeltaOperation } from 'quill'
import { IconButton, Menu, MenuButton, MenuDivider, MenuList, MenuOptionGroup } from '@chakra-ui/react'
import { DollarCircleOutlined, HourglassOutlined, OneToOneOutlined, SettingOutlined, ShareAltOutlined } from '@ant-design/icons'

import { FlexRow } from '../../FlexboxReusables/FlexItems'
import PurchaseOptions from './Options/PurchaseOptions'
import EditorSettingsOption from './Options/EditorSettingsOption'
import ShareOption from './Options/ShareOption'
import { exportAsPdf } from '../pdfExport'
import type { Course } from '../../Course/types'
import styled from 'styled-components'
import CertificateValidityOption from './Options/CertificateValidityOption'

type OptionsMenuProps = {
  course: Course
  deleteCourse: (id: number) => void
}

const OptionsMenu: React.FC<OptionsMenuProps> = ({ course, deleteCourse }) => {
  return (
    <FlexRow justifyContent='flex-end'>
      <Menu closeOnSelect={false} matchWidth>
        <MenuButton
          as={IconButton}
          icon={<SettingOutlined />}
          variant='outline'
          height={8}
          width={12}
          marginRight={'1em'}
        />
        <MenuList>
          <MenuOptionGroup
            title={(
              <TitleRow>
                <DollarCircleOutlined style={{marginRight: '0.5em'}}/>
                Kaufoptionen {/* TODO: i18n */}
              </TitleRow>
            ) as unknown as string} // as per types this does not accept JSX Elements but it works fine.
          >
            <PurchaseOptions
              canBePurchased={course.canBePurchased}
              purchasePrice={course.purchasePrice || 0}
              course={course}
            />
          </MenuOptionGroup>
          <MenuDivider margin={'1em 0'}/>
          <MenuOptionGroup
            title={(
            <TitleRow>
              <OneToOneOutlined style={{marginRight: '0.5em'}}/>
              Editor-Einstellungen {/* TODO: i18n */}
            </TitleRow>
          ) as unknown as string}
          >
            <EditorSettingsOption
              course={course}
              deleteCourse={deleteCourse}
            />
          </MenuOptionGroup>
          <MenuDivider margin={'1em 0'}/>
          <MenuOptionGroup
            title={(
              <TitleRow>
                <ShareAltOutlined style={{marginRight: '0.5em'}}/>
                Teilen/Freigeben {/* TODO: i18n */}
              </TitleRow>
            ) as unknown as string}
          >
            <ShareOption
              courseId={course.id}
              exportAsPdf={() => exportAsPdf(course.pages[0].content.ops as DeltaOperation[], course.name)} // TODO: change this, this is only the first page!
            />
          </MenuOptionGroup>
          <MenuDivider margin={'1em 0'}/>
          <MenuOptionGroup
            title={(
              <TitleRow>
                <HourglassOutlined style={{marginRight: '0.5em'}}/>
                Zertifikatsgültigkeit {/* TODO: i18n */}
              </TitleRow>
            ) as unknown as string}
          >
            <CertificateValidityOption
              course={course}
              examValidityMonths={course.examValidityMonths}
            />
          </MenuOptionGroup>
        </MenuList>
      </Menu>
    </FlexRow>
  )
}

export default OptionsMenu

const TitleRow = styled.div`
  font-weight: bold;
  font-size: 1.1em;
`